import { useEffect, useState } from 'react';
import CreatableSelect from 'react-select/creatable';

import LoaderComponent from '@/components/LoaderComponent';
import ModalContainer from '@/components/modals/ModalContainer';
import ModalHeader from '@/components/modals/ModalHeader';
import { useTaskConfigurations } from '@/store/reducers';
import { useUpdateTaskJourneyMutation } from '@/features/task-configuration/api/taskConfigurationApi';
import { toastError, toastSuccess } from '@/components/Toast';

const EditJourneyModal = ({ onClose, journeyTitle = '', selectedJourney = {}, refetch }) => {
	const { taskList = [] } = useTaskConfigurations();
	const [updateTaskJourney, { isLoading }] = useUpdateTaskJourneyMutation();
	const [selectedEndTasks, setSelectedEndTasks] = useState([]);
	const [errors, setErrors] = useState(null);

	useEffect(() => {
		if (selectedJourney?.endActions?.length > 0) {
			const formattedEndActions = selectedJourney?.endActions?.map((item) => ({
				name: item?.name,
				value: item?.name,
				label: item?.name,
				id: item?.id
			}));
			setSelectedEndTasks(formattedEndActions);
		}
	}, [selectedJourney?.id]);

	const formatTaskList = () =>
		taskList?.map((task) => ({
			...task,
			name: task?.name,
			value: task?.taskValueType?.name,
			label: task?.name,
			id: task?.id,
			taskValueType: task?.taskValueType?.constant
		}));

	const isValidateForm = () => {
		const newErrors = {};
		if (selectedEndTasks?.length === 0) {
			newErrors.endJourney = 'Select when journey will end';
		}
		setErrors(newErrors);

		return Object.keys(newErrors)?.length === 0;
	};

	const handleUpdateEndJourney = () => {
		if (!isValidateForm()) return;

		updateTaskJourney({
			id: selectedJourney?.id,
			body: {
				name: selectedJourney?.name,
				startActionId: selectedJourney?.startAction?.id,
				endActionIds: selectedEndTasks?.map((item) => item?.id)
			}
		})
			.unwrap()
			.then(() => {
				toastSuccess('Update successful');
				refetch?.();
				onClose?.();
			})
			.catch((error) => {
				toastError(error?.data.message || 'Task Journey update failed!');
			});
	};

	return (
		<LoaderComponent loading={isLoading}>
			<ModalContainer className="update-sample-and-sales-modal">
				<div className="popup-wrapper width-420-modal shadow-16dp">
					<div className="common-popup update-sample-and-sales-modal">
						<ModalHeader title={`Journey: ${journeyTitle}`} onClose={onClose} />
						<div className="common-popup-body">
							<div className="row">
								<div className="col-md-12 pr-2">
									<div className="form-group no-shadow-react-select">
										<label htmlFor="task">Journey will end</label>
										<CreatableSelect
											placeholder="Select task"
											onChange={(value) => {
												setErrors(null);
												setSelectedEndTasks(value);
											}}
											value={selectedEndTasks}
											options={formatTaskList()}
											classNamePrefix="react-select"
											isMulti
											isValidNewOption={() => false}
										/>
										{errors?.endJourney && (
											<span className="error">{errors?.endJourney}</span>
										)}
									</div>
								</div>
							</div>
						</div>
						<div className="modal-footer">
							<div className="footer-buttons text-right">
								<button className="button outline size32 ml-2" onClick={onClose}>
									Cancel
								</button>
								<button
									className="button size32 ml-2"
									onClick={handleUpdateEndJourney}
									disabled={isLoading}
								>
									Submit
								</button>
							</div>
						</div>
					</div>
				</div>
			</ModalContainer>
		</LoaderComponent>
	);
};

export default EditJourneyModal;
